/**
 * Formata valor de câmbio com precisão adequada
 * - BRL: 2 casas decimais fixas
 * - Outras moedas: até 10 casas decimais, removendo zeros à direita
 *
 * Antes o câmbio estrangeiro era truncado em 4 casas fixas, o que passou a
 * divergir do valor efetivamente usado nos cálculos (o câmbio pode ter até 10
 * casas). Mantemos até 10 casas e removemos zeros à direita para não poluir
 * a exibição quando o câmbio tem poucas casas.
 */
export const formatExchangeValue = (
  currency: string,
  value: number
): string => {
  if (!value) return "0";
  if (currency === "BRL") {
    return value.toFixed(2).replace(".", ",");
  }
  // Moeda estrangeira: até 10 casas, sem zeros à direita e sem ponto órfão.
  const formatted = value
    .toFixed(10)
    .replace(/0+$/, "")
    .replace(/\.$/, "");
  return formatted.replace(".", ",");
};
